import React from 'react';

export function VerticalDivider() {
    return <div className="vr" />;
}
